import { useCommentsScopeStore } from "@/stores/useCommentsScopeStore";
import { useEscapeCascade as useDsEscapeCascade } from "@hulahoop/ui";

export interface EscapeLayer {
  active: boolean;
  close: () => void;
}

export function useEscapeCascade(layers: readonly EscapeLayer[]): void {
  const open = useCommentsScopeStore((state) => state.open);
  const close = useCommentsScopeStore((state) => state.setOpen);
  useDsEscapeCascade([{ active: open, close: () => close(false) }, ...layers]);
}
